import {
  MarketingSection,
  SectionIntro,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";
import { cn } from "@/lib/utils";

const CARDS = [
  {
    title: "Skip the session",
    items: [
      "No DAW to open",
      "No audio to import into a session",
      "No manual separation step",
    ],
    card: "border-[rgba(82,52,160,0.08)] bg-[#F6F0FF]",
    color: "text-[#9652D6]",
    check: "before:bg-[#9652D6]",
    icon: (
      <>
        <rect x="6" y="9" width="29" height="28" rx="5" />
        <path d="M35 15h4a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H17a4 4 0 0 1-4-4v-2M14 24h2M20 19v10M26 16v16M32 21v6" />
      </>
    ),
  },
  {
    title: "Keep it together",
    items: [
      "Automatic separation on upload",
      "Stems saved with the original track",
      "Organized inside Audiolab",
    ],
    card: "border-[rgba(0,159,149,0.1)] bg-[#EAFAFA]",
    color: "text-[#08AAA4]",
    check: "before:bg-[#08AAA4]",
    icon: (
      <>
        <path d="M5 16h13l4 5h21v19H5z" />
        <rect x="10" y="20" width="31" height="22" rx="5" />
        <path d="M18 31h2M24 27v8M30 24v14M36 29v4" />
      </>
    ),
  },
  {
    title: "Put it to work",
    items: [
      "Download the parts you need",
      "Build alternate versions",
      "Include instrumentals and acapellas in your releases",
    ],
    card: "border-[rgba(255,113,26,0.11)] bg-[#FFF2E9]",
    color: "text-[#FF741F]",
    check: "before:bg-[#FF741F]",
    icon: (
      <>
        <rect x="6" y="10" width="29" height="30" rx="5" />
        <path d="M35 15h4a4 4 0 0 1 4 4v17M35 20h3a3 3 0 0 1 3 3v14" />
        <path d="m18 20 10 6-10 6z" />
      </>
    ),
  },
];

export default function StemsWhy() {
  return (
    <MarketingSection className="bg-white text-center">
      <SectionKicker className="!text-[#08AAA4]">Why Lutely</SectionKicker>
      <SectionTitle className="mx-auto !max-w-[1000px]">
        Your stems, right where you need them.
      </SectionTitle>
      <SectionIntro className="mx-auto !max-w-[760px] !leading-[1.6]">
        Upload once. Lutely automatically separates your track and keeps the
        stems connected to your music in Audiolab.
      </SectionIntro>
      <div className="mt-12 grid grid-cols-3 gap-[18px] text-left max-[950px]:grid-cols-1">
        {CARDS.map((card) => (
          <article
            key={card.title}
            className={cn(
              "min-h-[390px] rounded-[24px] border px-[30px] py-[31px] max-[950px]:min-h-0",
              card.card,
            )}
          >
            <div
              className={cn(
                "mb-[23px] grid size-[60px] place-items-center",
                card.color,
              )}
            >
              <svg
                viewBox="0 0 48 48"
                aria-hidden
                fill="none"
                stroke="currentColor"
                strokeWidth={2.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="size-[58px]"
              >
                {card.icon}
              </svg>
            </div>
            <h3 className="mb-[26px] mt-0 font-figtree text-[26px] font-[850] leading-[1.12] text-marketing-ink">
              {card.title}
            </h3>
            <ul className="m-0 grid list-none gap-[21px] p-0">
              {card.items.map((item) => (
                <li
                  key={item}
                  className={cn(
                    "relative min-h-[27px] pl-[45px] font-open-sans text-[16px] leading-[1.55] text-[#232B43] before:absolute before:left-0 before:top-0 before:grid before:size-7 before:place-items-center before:rounded-full before:text-[15px] before:font-black before:text-white before:content-['✓']",
                    card.check,
                  )}
                >
                  {item}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
      <p className="mb-0 mt-7 font-figtree text-[20px] font-[850] leading-[1.3] text-marketing-ink">
        Less file handling. More time for your music.
      </p>
    </MarketingSection>
  );
}
